import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Input, Row, Select, Tag, Typography } from "antd";
import { Option } from "antd/lib/mentions";
import { Icon } from "assets/icons";
import CustomModal from "components/CustomModal";
import CustomTable from "components/CustomTable";
import CustomTextHiddenLine from "components/CustomTextHiddenLine";
import { t } from "i18next";
import { SEARCH_TYPE, SELLING_STATUS } from "pages/App/Product/constants";
import { Link } from "react-router-dom";
import { formatCurrency } from "utils/helperFuncs";

import { PRODUCT_INPUT_TYPE } from "config/constants";
import {
  FilterInstockVat,
  FilterLevelPrice,
  FilterManufacture,
  FilterStatus,
  FilterVatPercent,
} from "pages/App/Product/Product/List/components/FilterProduct";
import TagsList from "pages/App/Product/Product/List/components/TagsList";
import { useProductShowModal } from "./useProductShowModal";

export const ProductShowModal = ({ visible, onCancel, voucherID }) => {
  const {
    loadingProduct,
    productData,
    paginationData,
    prodAtt,
    warehouses,
    handleSearch,
    onTableChange,
    renderProductAttributes,
    renderChildrenInStock,
    params,
    dataManufactures,
    loadingManufactures,
    listWarehouse,
    loadingWarehouses,
    setParams,
    filterProductExtra,
    filterProductPrices,
    searchType,
    itemsSearchBulk,
    handleChangeSelectSearch,
    handleSelectSearchType,
  } = useProductShowModal({ voucherID });

  const columns = [
    {
      title: "THÔNG TIN SẢN PHẨM",
      dataIndex: "code",
      width: 250,
      fixed: "left",
      render: (_, record) => {
        return (
          <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
            <Link target={"_blank"} to={`/product/detail/${record?.id}`} className="linked-text">
              <Typography.Link strong>{record?.code}</Typography.Link>
            </Link>
            <CustomTextHiddenLine text={record?.name} line={2} />
          </div>
        );
      },
    },
    {
      title: t("product.tableTitle.brand"),
      dataIndex: ["manufacturer", "name"],
      align: "center",
      render: (_, record) => <div>{record?.manufacturer?.name ? record.manufacturer.name : "- -"}</div>,
      filterDropdown: <FilterManufacture dataManufactures={dataManufactures} onFilter={filterProductExtra} />,
    },
    {
      title: t("product.tableTitle.warranty"),
      dataIndex: "warranty",
      align: "center",
      render: (_, record) => <div>{record?.warranty ? `${record.warranty} ${t("common.month")}` : "- -"}</div>,
    },
    ...renderProductAttributes(prodAtt),
    {
      title: "LOẠI % VAT",
      dataIndex: "vatPercent",
      align: "center",
      render: (_, record) => {
        return <div>{record.vatPercent >= 0 ? `${record.vatPercent}%` : "KCT"}</div>;
      },
      width: 150,
      editable: "true",
      inputType: PRODUCT_INPUT_TYPE.VAT_PERCENT,
      filterDropdown: <FilterVatPercent onFilter={filterProductExtra} defaultValue={params.filters.vatPercent} />,
    },
    {
      title: "GIÁ CÓ VAT",
      dataIndex: ["productPrices", "priceVat"],
      align: "right",
      render: (_, record) => {
        return (
          <div>
            {record?.productPrices?.priceVat ? formatCurrency(record?.productPrices?.priceVat) : formatCurrency(0)}
          </div>
        );
      },
      editable: "true",
      inputType: PRODUCT_INPUT_TYPE.CURRENCY,
      filterDropdown: (
        <FilterLevelPrice
          onFilter={(priceLevel) => {
            filterProductPrices(priceLevel, "priceVat");
          }}
          defaultValue={params.filters.priceVat}
        />
      ),
    },
    {
      title: <span>{t("product.tableTitle.inStockVat")}</span>,
      align: "center",
      render: (_, record) => {
        return (record?.stocks && record?.stocks[0].quantityRealStockHasVat) ?? 0;
      },
      width: 150,
      filterDropdown: <FilterInstockVat onFilter={filterProductExtra} defaultValue={params.filters.realStockHasVat} />,
    },
    {
      title: t("product.tableTitle.inStock"),
      children: renderChildrenInStock(warehouses),
      align: "center",
    },
    {
      title: t("product.tableTitle.inStock"),
      align: "right",
      render: (_, record) => <div>{record?.stocks?.at(0).quantity || "- -"}</div>,
    },
    {
      title: t("product.tableTitle.status"),
      dataIndex: "isActive",
      align: "center",
      editable: "false",
      fixed: "right",
      filterDropdown: <FilterStatus onFilter={filterProductExtra} defaultValue={params?.filters?.sellingStatuses} />,
      render: (_, record) => {
        return (
          <div>
            {record?.sellingStatus === SELLING_STATUS.AVAILABLE && (
              <Tag className="custom-tag-status-product-available">Đang kinh doanh</Tag>
            )}
            {record?.sellingStatus === SELLING_STATUS.UNAVAILABLE && (
              <Tag className="custom-tag-status-product-unavailable">Ngừng kinh doanh</Tag>
            )}
            {record?.sellingStatus === SELLING_STATUS.CONTACT && (
              <Tag className="custom-tag-status-product-contact">Liên hệ</Tag>
            )}
          </div>
        );
      },
    },
  ];

  return (
    <div className="custom-modal-select-product">
      <CustomModal
        {...{
          message: <Typography.Title level={4}>Danh sách sản phẩm áp dụng ưu đãi</Typography.Title>,
          footer: false,
          width: "90%",
          visible: visible,
          onOke: onCancel,
          onCancel: onCancel,
          buttonLoading: loadingProduct,
          hideCancelButton: true,
          okeButtonLabel: "Đóng",
          children: (
            <>
              <Row
                gutter={[16, 4]}
                style={{
                  alignItems: "center",
                  borderRadius: "8px",
                  margin: 0,
                }}
              >
                <Col span={24}>
                  <Row gutter={[16]} style={{ alignItems: "flex-end" }}>
                    <Col span={12}>
                      <div style={{ height: "32px", display: "flex", alignItems: "center" }}>
                        <Typography.Text strong>{t("campaign.combo.searchAdvance")}</Typography.Text>
                      </div>
                      <div className="custom-search-product-wrapper">
                        <Input.Group compact>
                          <Select
                            onChange={handleSelectSearchType}
                            defaultValue={searchType}
                            value={searchType}
                            className="select-search-type"
                          >
                            <Option value={SEARCH_TYPE.SINGLE}>Tìm kiếm từng mã sản phẩm</Option>
                            <Option value={SEARCH_TYPE.BULK}>Tìm kiếm hàng loạt</Option>
                          </Select>
                          {searchType === SEARCH_TYPE.SINGLE ? (
                            <Input
                              prefix={<FontAwesomeIcon icon={Icon.faSearch} />}
                              placeholder={t("product.searchPlaceholder")}
                              onChange={handleSearch}
                              allowClear={true}
                              defaultValue={params.filters.query}
                              style={{ width: "350px" }}
                            />
                          ) : (
                            <Select
                              mode="tags"
                              value={itemsSearchBulk}
                              onChange={handleChangeSelectSearch}
                              placeholder="Tìm kiếm các mã sản phẩm được ngăn cách với nhau bằng dấu phẩy/ đấu cách"
                              className="custom-select-search-product"
                              open={false}
                              dropdownStyle={{ display: "none" }}
                            />
                          )}
                        </Input.Group>
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col span={24}>
                  <TagsList
                    listFilter={params.filters}
                    dataManufactures={dataManufactures}
                    loadingManufactures={loadingManufactures}
                    dataWarehouses={listWarehouse}
                    loadingWarehouses={loadingWarehouses}
                    dataAttributes={prodAtt}
                    params={params}
                    setParams={setParams}
                  />
                </Col>
              </Row>
              <Row gutter={[16, 16]}>
                <Col span={24}>
                  <CustomTable
                    columns={columns}
                    loading={loadingProduct}
                    dataSource={productData}
                    rowKey={(record) => record?.id}
                    onChange={onTableChange}
                    pagination={{
                      total: paginationData?.total,
                      pageSize: paginationData?.limit,
                      current: paginationData?.offset / paginationData?.limit + 1 || 1,
                      showSizeChanger: false,
                    }}
                    scroll={{ x: "2500px", y: "500px" }}
                  />
                </Col>
              </Row>
            </>
          ),
        }}
      />
    </div>
  );
};
